(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pv-product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__pvQuickAddBound) return;
    window.__pvQuickAddBound = true;

    document.addEventListener('submit', function (event) {
      const form = event.target.closest('form[data-pv-quick-add]');
      if (!form) return;
      event.preventDefault();

      const button = form.querySelector('[data-pv-quick-add-button]');
      const label = form.querySelector('[data-pv-quick-add-label]');
      const originalText = label ? label.textContent : '';
      if (button) button.setAttribute('data-pv-state', 'adding');

      // Dawn renders the cart UI via either <cart-notification> or <cart-drawer>.
      // Whichever one exists tells us which sections need re-rendering after add.
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

      const formData = new FormData(form);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      fetch(window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : form.action, {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData,
      })
        .then(function (res) { return res.json(); })
        .then(function (response) {
          if (response.status) {
            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartError, {
                source: 'pv-quick-add',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
            }
            if (button) button.setAttribute('data-pv-state', '');
            if (label) label.textContent = originalText;
            return;
          }

          // Update header bubble + notification/drawer in one call.
          if (cart && typeof cart.renderContents === 'function') {
            if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
            cart.renderContents(response);
          }

          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'pv-quick-add',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          }

          if (button) button.setAttribute('data-pv-state', 'added');
          if (label) label.textContent = 'Dodano ✓';
          setTimeout(function () {
            if (button) button.setAttribute('data-pv-state', '');
            if (label) label.textContent = originalText;
          }, 1800);
        })
        .catch(function (e) {
          console.error('[pv-quick-add]', e);
          if (button) button.setAttribute('data-pv-state', '');
          if (label) label.textContent = originalText;
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
